import firebase from 'firebase/app';
import 'firebase/database';

const state = {
  about: ""
};

const getters = {
  about: state => {
    return state.about;
  }
};

const mutations = {
  loadAbout(state, payload) {
    state.about = payload;
  },

  saveAbout(state, payload) {
   state.about = payload;
  }
};


const actions = {

  saveAbout({ commit }, payload) {
    firebase
      .database()
      .ref('content/about/')
      .set(payload, error => {
        if (error) {
          // The write failed...
          commit('showMessage', {
            type: 'error',
            message: 'Error saving About, Try again!'
          });
          console.log(error);
        } else {
          commit('showMessage', { message: 'About saved successfully!' });
          commit('saveAbout', payload);
        }
      });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/about.js